// extracted by mini-css-extract-plugin
export default {"body":"body-kkjp_","warning":"warning-_Z5bI"};